import { useCallback } from 'react';
import { useGameState } from '../GameProvider';
import { useTimer } from '../hooks/useTimer';
import gameService from '../gameService';

export default function ResultsScreen() {
  const state = useGameState();
  const { gameId, uid, dealerUid, players, betweenRoundsReady, betweenRoundsTimerStart } = state;
  const isDealer = uid === dealerUid;

  // Between-rounds 60s timer
  const handleBetweenRoundsExpire = useCallback(async () => {
    if (!isDealer) return;
    // Auto-sit-out unready players
    const activeUids = Object.entries(players)
      .filter(([, p]) => !p.sittingOut && !p.kicked)
      .map(([id]) => id);

    for (const pUid of activeUids) {
      if (!betweenRoundsReady[pUid]) {
        await gameService.toggleSitOut(gameId, pUid, 'lobby');
      }
    }
  }, [isDealer, players, betweenRoundsReady, gameId]);

  useTimer(
    betweenRoundsTimerStart,
    60,
    handleBetweenRoundsExpire
  );

  // This component manages results logic only
  // Visual rendering happens in PokerTable via state
  return null;
}
